import styled from 'styled-components'
import { Colors, Spacing } from 'cio-design-library/design-tokens'
import Typography, { FontWeights } from 'builder/styles/typography'

export const Column = styled.div`
  display: flex;
  flex-flow: column;
`

export const Container = styled(Column)`
  gap: ${Spacing.L};
  max-width: 672px;
`

export const Section = styled(Column)`
  gap: ${Spacing.M};
`

export const SectionHeader = styled.div`
  ${Typography.S};
  ${FontWeights.DemiBold};
`

export const ItemList = styled(Column)`
  gap: ${Spacing.L};
`

export const Item = styled(Column)`
  gap: ${Spacing['2XS']};
`

export const ItemHeader = styled.div`
  ${Typography.Subhead};
  ${FontWeights.Medium};
`

export const ItemDuration = styled.div`
  color: ${Colors.Neutral50};
`

export const ItemDescription = styled.div``

export const BadgeList = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: ${Spacing.XS};
`

export const Badge = styled.div`
  padding: 6px 10px;
  border-radius: ${Spacing['3XS']};
  background-color: ${Colors.Neutral10};
  white-space: nowrap;
`
